import * as React from "react";
import { graphql, type HeadFC, type PageProps } from "gatsby";
import Layout from "../components/layout";
import PostCard from "../components/postCard";
import { ArticlesQuery } from "../types/articles";

const IndexPage: React.FC<PageProps<ArticlesQuery>> = ({ data }) => {
  const articles = data.allArticlesJson.nodes;
  return (
    <Layout>
      <div className="py-[70px] flex flex-col gap-[60px]">
        <div className="w-full">
          <PostCard data={articles[0]} direction="row" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
          <div className="">
            <PostCard data={articles[1]} direction="column" />
          </div>
          <div className="">
            <PostCard data={articles[2]} direction="column" />
          </div>
          <div className="">
            <PostCard data={articles[3]} direction="column" />
          </div>
          <div className="">
            <PostCard data={articles[4]} direction="column" />
          </div>
          <div className="">
            <PostCard data={articles[5]} direction="column" />
          </div>
          <div className="">
            <PostCard data={articles[6]} direction="column" />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IndexPage;

export const Head: HeadFC = () => <title>Biz360 - Webflow HTML website template</title>;

export const query = graphql`
  query {
    allArticlesJson {
      nodes {
        id
        image {
          publicURL
        }
        title
        short_text
        category
      }
    }
  }
`;
